export const createComboProductInputMapper = (fields) => {
  return {
    name: fields.name,
    description: fields.description,
    presentation: fields.presentation,
    categoryId: fields.category.id,
    isPublicSale: !fields.isWholesaler, // Default to public for normal products, and hidden for wholesalers
    isActive: true,
    tax: Number(parseFloat(fields.tax).toFixed(2)),
    basePrice: Number(parseFloat(fields.price).toFixed(2)),
    price: Number(parseFloat(fields.price).toFixed(2)),
    thumbnail: fields.thumbnail,
    isWholesaler: fields.isWholesaler,
    items: fields.comboItems.map((i) => {
      return {
        itemProductId: i.id,
        itemProductAmount: i.quantity,
      };
    }),
  };
};
